import type { UsersErrorDTO } from '@empathyco/playboard-core-domain'
import type { ErrorMessage } from '../../models'
import { useApiError } from '../use-api-error'

export function useUsersError({
  messages,
}: {
  messages?: { fields: Record<string, { label: string }> }
} = {}) {
  const { getErrorMessage: getApiErrorMessage } = useApiError()

  function getErrorMessage(error: UsersErrorDTO): ErrorMessage {
    const result = getApiErrorMessage(error)
    if (error.details && 'errors' in error.details && Object.keys(error.details.errors).length) {
      result.message += '<ul>'
      Object.entries(error.details.errors).forEach(([field, error]) => {
        result.message += `<li><b>${getFieldLabel(field)}</b>: ${error}</li>`
      })
      result.message += '</ul>'
    }
    return result
  }

  function getFieldLabel(field: string): string {
    return messages?.fields[field]?.label ?? field
  }

  return {
    getErrorMessage,
  }
}
